import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";

export const Route = createFileRoute("/accessories")({
  head: () => ({
    meta: [
      { title: "Leather Accessories — KAKAIYS" },
      { name: "description", content: "Leather gloves, watch straps, belts, keychains, cardholders and passport covers — hand-finished in calfskin and lambskin." },
      { property: "og:title", content: "Leather Accessories — KAKAIYS" },
      { property: "og:description", content: "Gloves, watch straps, belts, keychains, cardholders, passport covers." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/seed/femme-driving-gloves-noir.jpg" },
      { property: "og:url", content: "https://kakaiys.com/accessories" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/accessories" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Leather Accessories — KAKAIYS",
          description: "Leather gloves, watch straps, belts, keychains, cardholders and passport covers.",
          url: "https://kakaiys.com/accessories",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Accessories"
      title="The Small Things."
      subtitle="Belts, gloves, watch straps, keychains, cardholders and passport covers — finished by the same hands as the jackets."
      filterCategory="Accessories"
      subFilters={[
        { label: "Belts", value: "belts" },
        { label: "Gloves", value: "gloves" },
        { label: "Watch Straps", value: "watch-straps" },
        { label: "Keychains", value: "keychains" },
        { label: "Cardholders", value: "cardholders" },
        { label: "Passport Covers", value: "passport-covers" },
      ]}
      subFilterKey="subcategory"
    />
  ),
});
